// main tools
import { createContext } from 'react'

// types
import { ConfirmDialogProps } from '@centria-ui-atoms/confirm-dialog'
import { Toast } from 'primereact/toast'

type CreateContextDataType = {
  toast: () => Toast | undefined
  confirmDialog: (options: ConfirmDialogProps) => void
}

export const AppContext = createContext<CreateContextDataType>({
  toast: () => undefined,
  confirmDialog: () => undefined
})
